import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {OfflineInterceptor} from 'app/offline/offline-interceptor';

@NgModule({
  providers: [{provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true}],
})
export class OfflineModule {}
